module.exports = __webpack_public_path__ + "static/media/dinner2.fd613053.jpg";